import { render, staticRenderFns } from "./quotations-amount.vue?vue&type=template&id=5f3ff85c&scoped=true"
import script from "./quotations-amount.vue?vue&type=script&lang=js"
export * from "./quotations-amount.vue?vue&type=script&lang=js"
import style0 from "./quotations-amount.vue?vue&type=style&index=0&id=5f3ff85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ff85c",
  null
  
)

export default component.exports